import { CommonEntrypoint } from "entrypoint/CommonEntrypoint";
import RefundContMain from "presentation/view/container/Refund/RefundContMain";

CommonEntrypoint(<RefundContMain />)